(function() {
  // 只在移动端且是轮播图模式时执行
  if (window.innerWidth > 750) return;
  
  const carouselBox = document.querySelector('.mt-pic2-box.mt-pic2-carousel');
  if (!carouselBox) return;
  
  const indicators = document.querySelectorAll('.mt-pic2-carousel-indicator');
  const items = carouselBox.querySelectorAll('.mt-pic2-carousel-item');
  
  if (!indicators.length || !items.length) return;
  
  let currentIndex = 0;
  let scrollTimeout = null;
  
  // 更新指示器
  function updateIndicators(activeIndex) {
    indicators.forEach((indicator, index) => {
      if (index === activeIndex) {
        indicator.classList.add('active');
      } else {
        indicator.classList.remove('active');
      }
    });
  }
  
  // 使用 IntersectionObserver 精确检测当前可见的图片
  const observerOptions = {
    root: carouselBox,
    rootMargin: '0px',
    threshold: 0.5 // 当图片可见超过50%时认为它是当前图片
  };
  
  const observer = new IntersectionObserver(function(entries) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const index = Array.from(items).indexOf(entry.target);
        if (index !== -1 && index !== currentIndex) {
          currentIndex = index;
          updateIndicators(index);
        }
      }
    });
  }, observerOptions);
  
  // 观察所有图片
  items.forEach(item => {
    observer.observe(item);
  });
  
  // 获取每个item的实际宽度（包括padding）
  function getItemWidth() {
    if (items.length === 0) return 0;
    const firstItem = items[0];
    const style = window.getComputedStyle(firstItem);
    const width = firstItem.offsetWidth;
    const paddingLeft = parseFloat(style.paddingLeft) || 0;
    const paddingRight = parseFloat(style.paddingRight) || 0;
    return width + paddingLeft + paddingRight;
  }
  
  // 滚动到指定索引（仅用于点击指示器）
  function scrollToIndex(index) {
    if (index < 0 || index >= items.length) return;
    
    const itemWidth = getItemWidth();
    const targetScroll = index * itemWidth;
    
    // 使用 smooth 滚动，让 CSS scroll-snap 自然对齐
    carouselBox.scrollTo({
      left: targetScroll,
      behavior: 'smooth'
    });
    
    currentIndex = index;
    updateIndicators(index);
  }
  
  // 点击指示器切换
  indicators.forEach((indicator, index) => {
    indicator.addEventListener('click', function() {
      scrollToIndex(index);
    });
  });
  
  // 初始化
  updateIndicators(0);
})();
